var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 15.5199L1.39001 1.38988M1.39001 1.38988C2.08001 0.699884 3.10001 0.469884 4.02001 0.789884L23.29 7.51988C23.57 7.61988 23.83 7.77988 24.05 7.99988C24.84 8.78988 24.84 10.0699 24.05 10.8599H24.04C23.84 11.0599 23.6 11.2399 23.35 11.3699L15.51 15.5199L11.36 23.3599C11.23 23.6099 11.05 23.8499 10.85 24.0499C10.06 24.8399 8.78001 24.8399 7.99001 24.0499C7.77001 23.8399 7.61001 23.5799 7.51001 23.2899L0.790006 4.01988C0.470006 3.09988 0.700006 2.07988 1.39001 1.38988Z",
    stroke: "#8533eb",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.a04dfe550d8403ac390cd674af35a04d.svg";
export { ForwardRef as ReactComponent };